import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();
export const postAddUser = (payload) => api.create(url.POST_ADD_USER, payload);
export const postLoginGuest = (payload) => api.create(url.POST_LOGIN_GUEST, payload);
export const getUserList = () => api.get(url.GET_USER_LIST);
export const deleteUser = (id) => api.delete(url.DELETE_USER(id));
export const patchUpdateUser = (id, payload) => api.update(url.GET_USER_DETAILS(id), payload);
export const getUserDetails = (id) => api.get(url.GET_USER_DETAILS(id));
// Nadpisuje plik qr_{eventId}.svg nowym kodem — tylko dla głównego admina.
export const regenerateUserQrCode = (userId) => api.create(url.POST_REGENERATE_USER_QR(userId), {});
// Blokada / odblokowanie konta club admina — tylko dla głównego admina.
export const setUserEnabled = (userId, enabled) => api.create(url.POST_SET_USER_ENABLED(userId), { enabled });
